import React from 'react';
import { 
  ArrowRight, 
  Droplet, 
  Thermometer, 
  ShieldCheck, 
  Zap, 
  MapPin, 
  Clock 
} from 'lucide-react';

const Herosection = () => {
  const brandBlue = '#004e6e'; 
  const brandRed = '#ff4a4a';

  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-slate-50 pt-20 lg:pt-0">
      
      {/* 1. LAYER: DYNAMIC BACKGROUND TEXTURE */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 left-0 w-full h-full opacity-[0.03] pointer-events-none" 
             style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23004e6e' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")` }}>
        </div>
        {/* Glow Effects */}
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-blue-500/10 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-24 right-0 w-[500px] h-[500px] bg-red-500/5 rounded-full blur-[150px]"></div>
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          
          {/* LEFT CONTENT: TYPOGRAPHY & CTA */}
          <div className="w-full lg:w-1/2 space-y-8">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-2 px-3 py-1 bg-white border border-slate-200 rounded-full shadow-sm">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                </span>
                <span className="text-[10px] font-black uppercase tracking-widest text-slate-600">24/7 Notfallservice</span>
              </span>
              <span className="text-[10px] font-black uppercase tracking-widest text-slate-400 flex items-center gap-1">
                <MapPin size={12} /> Büren an der Aare
              </span>
            </div>

            <h1 className="text-5xl md:text-8xl font-black leading-[0.9] tracking-tighter" style={{ color: brandBlue }}>
              HANDWERK <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff4a4a] to-[#ff8585]">MIT STIL.</span>
            </h1>

            <p className="text-xl text-slate-500 max-w-lg leading-relaxed font-medium">
              Präzise Sanitärinstallationen und effiziente Heizsysteme. 
              Wir kombinieren Schweizer Qualität mit modernster Technik für Ihr Zuhause.
            </p>

            <div className="flex flex-wrap gap-5">
              <a 
  href="#contact" 
  className="group relative inline-flex items-center justify-center px-10 py-5 bg-[#004e6e] text-white rounded-2xl font-black text-sm uppercase tracking-widest shadow-2xl shadow-blue-900/20 transition-all hover:-translate-y-1 overflow-hidden"
>
  <span className="relative z-10 flex items-center gap-3">
    Offerte anfordern 
    <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
  </span>
  
  {/* The red background that slides up on hover */}
  <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-red-400 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></div>
</a>

              <div className="flex items-center gap-4 px-6 py-5 bg-white border border-slate-100 rounded-2xl shadow-sm group cursor-pointer hover:border-blue-100 transition-all">
                <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-all">
                  <Zap size={20} />
                </div>
                <div>
                  <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Schnell-Check</p>
                  <p className="text-sm font-bold text-slate-800">Unsere Leistungen</p>
                </div>
              </div>
            </div>

            {/* TRUST INDICATORS */}
            <div className="pt-8 border-t border-slate-200 flex gap-8">
              <div className="flex flex-col">
                <span className="text-2xl font-black text-slate-800">15+</span>
                <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Jahre Erfahrung</span>
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-black text-slate-800">100%</span>
                <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Schweizer Qualität</span>
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-black text-slate-800">Top</span>
                <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Kundenservice</span>
              </div>
            </div>
          </div>

          {/* RIGHT CONTENT: THE VISUAL COMPOSITION */}
          <div className="w-full lg:w-1/2 relative">
            <div className="relative w-full aspect-square max-w-[600px] mx-auto">
              
              {/* Main Image Container */}
              <div className="absolute inset-4 rounded-[3rem] overflow-hidden shadow-2xl rotate-2">
                <img 
                  src={process.env.PUBLIC_URL + '/img/HEROSECTION.jpeg'} 
                  alt="Modern Bathroom Design" 
                  className="w-full h-full object-cover "
                />
              </div>

        

             

              {/* ACCENT CIRCLE */}

            </div>
          </div>

        </div>
      </div>

   
    </section>
  );
};

export default Herosection;